import React from 'react'
import moment from 'moment'
import { FormattedMessage } from 'react-intl'
import Panel from '../panel'
import OpenHome from './open_home'

export default function OpenHomesPanel({ property }) {
  const openHomes = property.attributes.settings?.open_homes?.filter((el) => {
    return moment().unix() < moment(el.end_date).unix()
  })

  if (!openHomes || openHomes.length === 0) {
    return null
  }

  return (
    <Panel title={<FormattedMessage id="open-homes.schedule" />}>
      {openHomes.map((openHome) => {
        return (
          <OpenHome
            key={openHome.id}
            openHome={openHome}
            propertyId={property.id}
          />
        )
      })}
    </Panel>
  )
}
